class Faq extends HTMLElement {
  constructor() {
    super();
    const itemTitles = document.querySelectorAll(".faq-category__anchor");
    const container = document.querySelector(".anchor-holder");
    if (itemTitles) {
      itemTitles.forEach((itemTitle) => {
        const itemTemplate = `<a href="#${itemTitle.id}" class="button button--ghost">${itemTitle.innerHTML}</a>`;
        container.insertAdjacentHTML("beforeend", itemTemplate);
      });
    }
  }
}
if (customElements.get("faq-holder") === void 0) {
  customElements.define("faq-holder", Faq);
}
